import { useEffect } from 'react';
import { getAllAdminSchedules } from 'features/admin-campaigns/async';
import { adminSchedulesDataSelector } from 'features/admin-campaigns/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export function useFetchAdminSchedulesEffect() {
  const dispatch = useAppDispatch();
  const schedules = useAppSelector(adminSchedulesDataSelector);

  useEffect(() => {
    if (schedules != null) {
      return;
    }

    dispatch(getAllAdminSchedules());
  }, [dispatch, schedules]);
}
